import { Button } from "@mui/material";

export default function SendViaEmail(props: any) {
  return (
    <Button color="primary" size={props.size || "small"} variant="outlined" {...props}>
      {props.label || "Send Via Email"}
    </Button>
  );
}
